import { render, staticRenderFns } from "./MenuCombos.vue?vue&type=template&id=6e56ab15&scoped=true"
import script from "./MenuCombos.vue?vue&type=script&lang=js"
export * from "./MenuCombos.vue?vue&type=script&lang=js"
import style0 from "./MenuCombos.vue?vue&type=style&index=0&id=6e56ab15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e56ab15",
  null
  
)

export default component.exports